import React from 'react';
import { motion } from 'framer-motion';

const AboutStory: React.FC = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center" style={{ gap: '20px' }}>
          {/* Left side - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full max-w-md mx-auto lg:mx-0 lg:flex-none lg:w-[30%] lg:max-w-[30%] flex justify-center lg:justify-start"
          >
            <div style={{ width: '100%', aspectRatio: '3/4', position: 'relative', overflow: 'hidden', borderRadius: '24px' }}>
              <img
                src="/pics/our story.JPG"
                alt="Our Story"
                className="rounded-3xl"
                style={{ 
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                  margin: 0,
                  padding: 0,
                  borderRadius: '24px'
                }}
                loading="lazy"
                decoding="async"
              />
            </div>
          </motion.div>

          {/* Right side - Text content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-left flex-1"
            style={{ padding: 0, margin: 0, minWidth: 0 }}
          >
            <h2 
              className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8" 
              style={{ 
                fontFamily: "'Montserrat', sans-serif",
                color: '#EF3F23',
                letterSpacing: '-0.05em'
              }}
            >
              Our Story
            </h2>
            <div className="space-y-6">
              <p 
                className="text-base text-gray-300 leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Bizani Media Productions (Pvt) Ltd was founded in Zimbabwe in 2017. We are a content creation company that helps you to attract attention and communicate better about your work.
              </p>
              <p 
                className="text-base text-gray-300 leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Our company provides multimedia production services, including video production, documentaries, branding and digital services that help organizations of all sizes to meet their communication needs.
              </p>
              <p 
                className="text-base text-gray-300 leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                The word 'bizani' is translated to mean 'call'. To call is to "cry out to (someone) in order to summon them or attract their attention".
              </p>
              <p 
                className="text-base text-gray-300 leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                We tell stories that engage, educate and activate audiences. When done right, content helps to achieve daily communication needs for project reporting, training, marketing, advertising, social media, branding and more.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
